export class EditModeContextModel {
	mouseUpCallbackName?: string;
	editModeDayOffset?: number;
	undoRedoTrigger = false;
	constructor(mcm?: Partial<EditModeContextModel>) {
		Object.assign(this, mcm);
	}
}
